import { HDAACCOUNTSARRAY } from 'constants/accounts'
import LogoAccount from 'components/ui/LogoAccount'
import { useMemberProfilesStore } from 'store/memberprofiles'
import useAuthStore from 'store/auth'
import { useMemo } from 'react'

const Index = (): JSX.Element => {
  const memberprofiles = useMemberProfilesStore((state) => state.memberprofiles)

  // fetch attributes from auth store (populated in App)
  const attributes = useAuthStore((state) => state.attributes)
  const attrsArray = Array.isArray(attributes) ? attributes : [attributes];
  const moduleCode = attrsArray[0].attributes['custom:moduleCode']
  const moduleProject = moduleCode ? String(moduleCode).toLowerCase() : 'generic'
  const isAdmin = attrsArray[0].attributes['profile'] === 'admin'

  const displayProject = useMemo(() => {
    const projectExists = HDAACCOUNTSARRAY.some(
      (acc) => acc.project === moduleProject
    )
    
    let project = projectExists ? moduleProject : 'generic'

    // Only apply Mad Butcher logic if memberprofiles is loaded
    if (project === 'hda_hmp' && memberprofiles.length > 0 && memberprofiles[0]?.memberStatus?.includes('Mad Butcher Xmas')) {
      project = 'hda_hmp_mbx'
    }

    return project
  }, [moduleProject, memberprofiles])

  return (
    <div
      className={
        'flex flex-col items-center justify-center gap-2 relative p-8 text-white rounded-xl w-72 bg-white'
      }
    >
      <LogoAccount project={displayProject} />
      {memberprofiles.map((item) => (
        <p
          key={item.traderId}
          className="text-lg font-light tracking-wider text-black text-center"
        >
          {item.cardNumber ? item.cardNumber : '---'}
        </p>
      ))}
    </div>
  )
}

export default Index
